import { Divider } from "@mui/material";
import { CreateCarUserTokenEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateCarUserTokenEntity";
import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { useSelector } from "react-redux";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import {
  ADD_ALLOCATIONS_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { handleDeleteOccupiedToken } from "../../../../../utils/MenuUtils";
import { isRequired } from "../../../../../utils/FormUtils";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../../utils/MessagesUtils";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import classes from "../WizardForm.module.css";
import AllocationCard from "../../../Cards/AllocationCard/AllocationCard";
import * as carUserTokenActionsService from "../../../../../services/ActionsService/CarUserTokenActionsService";
import AddSingleTokenAllocation from "./AddSingleTokenAllocation";
import SearchAutocompleteInput from "../../../Inputs/CustomInputs/SearchAutocompleteInput";
import { LENGTHS } from "../../../../../config/Config";

const AssignAllocationStep = forwardRef((props, ref) => {
  const [errors, setErrors] = useState({});

  // allocation add
  const showAddNewUserButton = useSelector((state) => state.common.showAddNewUserButton);

  // handles when fob is not supported - hide assignedParkers list (cause assignedParkers.length > 1 - parkers added on select)
  const showAssigneFobOptions = useSelector((state) => state.common.showAssigneFobOptions); 
  const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);

  // from token component
  const [hasStepErrors, setHasStepErrors] = useState(false);
  const [showSummaryStep, setShowSummaryStep] = useState(props?.isEditMode);
  const [occupiedTokens, setOccupiedTokens] = useState(
    props?.isEditMode ? props?.carUserTokens : []
  );

  let selectedSite = props.selectedSite;
  let localSelectedParker = null;

    // added
    //const AddSingleTokenWithFobRef = useRef();

    const addSingleTokenAllocationRef = useRef();

    // added
    useImperativeHandle(ref, () => ({
      //AddSingleTokenWithFobRef,
      occupiedTokens,
      setOccupiedTokens
    }));

  // search list values
  // let allocations = useSelector((state) => state.allocations.allocations); // for debug usage
  let parkersList = useSelector((state) => state.allocations.allocations)
    .map((allocation) => allocation.parker)
    .filter((parker) =>
      // filters parkersList selection by selected siteId && userTypeId (from userType step) && 
      // excludes already assigned parker from searchParker selection
      // filters seeing parkers from the same selected userTypes 
      // exclude parkers that are not from the same selected userType
      parker.utronUser.userSites.some((us) => us.siteId === props.site) && // filter by selected userSite
      parker.utronUser.userToUserTypes.some((ut) => ut.userTypeId === props.userTypeId) && // filter by selected userType
      !props.assignedParkers.some(assigned => assigned.utronUser.id === parker.utronUser.id) && // exclude already assignedParkers
      props.foundedExistingParker?.id !== parker.utronUser.id // on existing case: exclude founded parker (parker that is founded from the phone search)
    ) 
    .map(
      (parker) =>
        new ListItem(
          parker.utronUser.id,
          `${parker.utronUser?.firstName} ${parker.utronUser?.lastName}`,
          parker
        )
    );
  parkersList = parkersList.filter(
    (item, index) =>
      parkersList.findIndex((parker) => item.id === parker.id) === index
  ); // distinct array

  const handleAssignTokenToFob = (token, skipFob = false) => {
    let occupiedTokenCopy = [...occupiedTokens];
    const assignedToken = {
      fob: props.fob === "" || skipFob ? null : props.fob,
      occupiedToken: token,
      tokenId: token?.id, 
    }; // fob: props.fob

    // validates that since selected new parker allocation, and there is already assigned parker
    // all relevant carUserTokens (for every added user)
    // will be associated to only one token 
    if (props.assignedParkers?.length === 0 || props.isFobSkipped) {
      occupiedTokenCopy.push(assignedToken);
      setOccupiedTokens(occupiedTokenCopy);
    }

    // prev code
    // occupiedTokenCopy.push(assignedToken);
    // setOccupiedTokens(occupiedTokenCopy);

    // allocation add -- inserts the carUserToken to the assignedParker - for ui
    // when fob supported - take selectedParker from formData,
    // when fob not supported - take localSelectedParker
    let selectedParkerCopy = props.isFobSkipped ? {...localSelectedParker} : {...props.selectedParker}; //{...localSelectedParker}; // {...props.selectedParker} 
    selectedParkerCopy.carUserTokens = occupiedTokenCopy.map((token) => {
      let carToken = new CreateCarUserTokenEntity(); // create carUserToken obj

      // populates the carUserToken obj
      const obj = {
        tokenId: token?.tokenId, 
        token: token?.occupiedToken,
        fob: props.fob === "" || skipFob ? null : props.fob, 
        userId: selectedParkerCopy.utronUser.id 
      };
      return { ...carToken, ...obj };
    });

    //update form
    props.handleChange({
      [INPUTS_PROPS.TOKENS]: occupiedTokenCopy.map(
        (token) => token?.occupiedToken
      ),
      [INPUTS_PROPS.CAR_USER_TOKEN]: [...props.carUserTokens, occupiedTokenCopy.map((token) => {
        let carToken = new CreateCarUserTokenEntity();
        const obj = {
          tokenId: token?.tokenId,
          token: token?.occupiedToken,
          fob: props.fob === "" || skipFob ? null : props.fob, 
          userId: selectedParkerCopy.utronUser.id 
        };
        return { ...carToken, ...obj };
      })],
      //allocation Add - add selectedParker to assignedParkers, 
      ["assignedParkers"] : [...props.assignedParkers, selectedParkerCopy],
      ["selectedParker"] : [selectedParkerCopy]
    });

    setShowSummaryStep(true);
  };

  const handleClearAllTokens = () => {
    setOccupiedTokens([]);
  };

  const handleDeleteAssignedParker = (id) => {
    // splice both in assignedParkers and carUserTokens
    let indexToDelete = props.assignedParkers?.findIndex(parker => parker.utronUser.id === id);
    let assignedParkersCopy = [...props.assignedParkers];
    let carUserTokensCopy = [...props.carUserTokens.flat()];
    assignedParkersCopy.splice(indexToDelete, 1);

    //indexToDelete = props.carUserTokens.flat().findIndex(cut => cut.userId === id);
    carUserTokensCopy.splice(indexToDelete, 1);

    if (assignedParkersCopy?.length === 0) {
      store.dispatch(commonActions.setShowAddNewUserButton(false));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      
      // clear all data
      handleClearAllTokens();
      props.handleChange({
        ["assignedParkers"] : [],
        ["carUserTokens"] : [],
        ["tokens"] : [],
        ["selectedParker"] : null,
        ["foundedExistingParker"] : null,
        ["fob"] : ""
      });
    }
    else { // update data
      props.handleChange({
        ["assignedParkers"] : assignedParkersCopy,
        ["carUserTokens"] : carUserTokensCopy
      });
    }
  };

  const handleDeleteTokenByIndex = (index) => {
    // added
    if (props.isFobSkipped) {
      props.handleChange({ ["carUserTokens"]: [] });
      store.dispatch(commonActions.setAssigneOption(null));
    }
    if (index > -1) {
      const token = occupiedTokens[index].occupiedToken;
      const userTokens = props.carUserTokens.map(
        (token) => token.occupiedToken
      );
      const userTokensIds = userTokens?.map((ot) => ot?.id);
      if (props.isEditMode && userTokensIds.includes(token?.id)) {
        const exsistOccupiedToken = occupiedTokens[
          index
        ].occupiedToken.carUserTokens?.find(
          (cut) => cut.userId === props?.userData?.id
        );
        if (exsistOccupiedToken) {
          handleDeleteOccupiedToken(
            props.userData,
            token?.displayValue,
            deleteCarUsertokenFromServer.bind(
              this,
              exsistOccupiedToken?.id,
              index
            )
          );
        }
      } else {
        deleteCarUsertokenFromView(index);
        if (props.fromGmt === undefined) {
          props.setIsShowSaveChanges(false);
        }
      }
    }
  };
  const deleteCarUsertokenFromView = (index) => {
    let occupiedTokenCopy = [...occupiedTokens];
    occupiedTokenCopy.splice(index, 1);
    setOccupiedTokens(occupiedTokenCopy);
  };

  const deleteCarUsertokenFromServer = (carUserTokenId, index) => {
    carUserTokenActionsService
      .deleteCarUserToken(carUserTokenId)
      .then((response) => {
        if (response.data.isSuccess) {
          showUpdateSuccessMessage();
          deleteCarUsertokenFromView(index);
        } else {
          showErrorMessage(response.data?.error);
        }
      });
  };

  const setShowStepError = (boolean) => {
    setHasStepErrors(boolean);
  };

  const handleChange = (event) => {
    if (event[INPUTS_PROPS.FOB]) {
      setErrors({
        ...errors,
        [INPUTS_PROPS.FOB]: isRequired(event[INPUTS_PROPS.FOB]),
      });
    }
    props.handleChange(event);
  };

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  if (props.currentStep !== ADD_ALLOCATIONS_FORM_STEPS.SEARCH_PARKER) {
    return null;
  }

  const handleAddNewUser = () => {
    store.dispatch(commonActions.setShowAddNewUserButton(false)); // allocation add

    // sets selectedParker to null to prepare for the next selection, clears fob input value
    props.handleChange({ ["selectedParker"]: null, ["fob"] : "" });
  };

  const handleSelectChange = (event) => {
    

    // with no fob difference -  test
    // store.dispatch(commonActions.setShowFobScannerInput(true));
    // store.dispatch(commonActions.setShowScanFobButton(false));
    // store.dispatch(commonActions.setShowAssigneFobOptions(false));
    // store.dispatch(commonActions.setAssigneOption(null)); 
    // store.dispatch(commonActions.setShowExsistingParkingAllocation(false));

    // let occupiedTokenCopy = [...occupiedTokens];
    // let selectedParkerCopy = {...props.selectedParker};
    // selectedParkerCopy.carUserTokens = occupiedTokenCopy.map((token) => {
    //   let carToken = new CreateCarUserTokenEntity(); // create carUserToken obj

    //   // populates the carUserToken obj
    //   const obj = {
    //     token: token?.occupiedToken,
    //     fob: props.fob === "" ? null : props.fob, // // fob: props.fob
    //     userId: selectedParkerCopy.utronUser.id // selectedParkerCopy.utronUser.id, assignedParker[0], props.assignedParkers.length > 0 ? props.assignedParkers[0].utronUser.id
    //   };
    //   return { ...carToken, ...obj };
    // });

    // push to assignedParkers - when not supported - adds parker on change
    //let obj = {event, "assignedParkers": [...props.assignedParkers, Object.values(event)]};
    // props obj
    let obj = { 
      "selectedParker": event.selectedParker,
      //"assignedParkers" : [...props.assignedParkers, event.selectedParker]
    };

    // create carUserToken to the next user according to the first assigned user
    // occurs only on at least one assignedParker & fob is not supported
    // add carUserToken to the rest assignedParkers
    let occupiedTokenCopy = [...occupiedTokens];
    let selectedParkerCopy = {...event.selectedParker};
    if (props.assignedParkers.length > 0 && props.isFobSkipped) {
       selectedParkerCopy.carUserTokens = occupiedTokenCopy.map((token) => {
        let carToken = new CreateCarUserTokenEntity(); // create carUserToken obj

        // populates the carUserToken obj
        const obj = {
          tokenId: token?.tokenId, 
          token: token?.occupiedToken,
          fob: props.fob === "" ? null : props.fob, 
          userId: selectedParkerCopy.utronUser.id 
        };
        return { ...carToken, ...obj };
      });

      obj = { 
        "selectedParker": event.selectedParker,
        "assignedParkers" : [...props.assignedParkers, selectedParkerCopy]
      };

      props.handleChange(obj);
    }

    if (props.assignedParkers.length > 0 && !props.isFobSkipped) {
      props.handleChange(obj);
    }

    localSelectedParker = event.selectedParker;

    // set the inner-steps according to the fob support & assigned parker
    if (!props.isFobSkipped /*props.selectedSite?.isFobsSupported*/) {
      // fob supported
      //isFobSkipped = false;
      store.dispatch(commonActions.setShowFobScannerInput(true)); // dif 
      store.dispatch(commonActions.setShowScanFobButton(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false)); // dif 
      store.dispatch(commonActions.setAssigneOption(null)); 
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));

      if (props.assignedParkers?.length === 0) {
        props.handleChange(event);
      }
    }
    else {
      // fob not supported
      //isFobSkipped = true;
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowScanFobButton(false));
      
      if (props.assignedParkers?.length === 0) {     
        //store.dispatch(commonActions.setShowAssigneFobOptions(true)); // dif 
        store.dispatch(commonActions.setShowAssigneFobOptions(false)); // dif 
        addSingleTokenAllocationRef.current.handleAssigneOptionChange(event, 1); // new allocation
        //store.dispatch(commonActions.setAssigneOption(null)); 
      }
      else {
        store.dispatch(commonActions.setShowAddNewUserButton(true));
        store.dispatch(commonActions.setShowAssigneFobOptions(false));
        store.dispatch(commonActions.setShowScanFobButton(false));
        //handleAssignTokenToFob(null);
        //props.handleChange({ ["selectedParker"]: null, ["fob"] : null });
      }


      // if (props.assignedParkers?.length === 0) {     
      //   store.dispatch(commonActions.setShowAssigneFobOptions(true)); // dif 
      //   store.dispatch(commonActions.setAssigneOption(null)); 
      // }
      // else {
      //   store.dispatch(commonActions.setShowAddNewUserButton(true));
      //   store.dispatch(commonActions.setShowAssigneFobOptions(false));
      //   store.dispatch(commonActions.setShowScanFobButton(false));
      //   //handleAssignTokenToFob(null);
      //   //props.handleChange({ ["selectedParker"]: null, ["fob"] : null });
      // }
      
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    }
  };

  return (
    <>
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.SEARCH_PARKER_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.SEARCH_PARKER_SUB_TITLE}
      </span>
      {/* Search Parker */}
      {props.selectedParker === null ? (
        <SearchAutocompleteInput 
          label={Strings.INPUT_LABELS.SEARCH_PARKER}
          id={INPUTS_PROPS.SELECTED_PARKER}
          onChange={handleSelectChange}
          list={parkersList}
          value={props?.selectedParker ? props?.selectedParker : ""}
          defaultValue={/*scopesList?.length > 0 ? scopesList[0] :*/ ""}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          startAdornment={<img src={Icons.SEARCH} />}
        />
        
        // <SelectInput
        //   label={Strings.INPUT_LABELS.SEARCH_PARKER}
        //   id={INPUTS_PROPS.SELECTED_PARKER}
        //   onChange={handleSelectChange}
        //   list={parkersList}
        //   value={props?.selectedParker ? props?.selectedParker : ""}
        //   defaultValue={/*scopesList?.length > 0 ? scopesList[0] :*/ ""}
        //   isStepSubmitted={props.isStepSubmitted}
        //   handleError={handleError}
        //   // hasError={!isRequired(props.selectedScope?.name).isValid}
        //   // errorMessage={getErrorMessage(isRequired(props.selectedParker?.firstName))}

        //   // todo: add startAdornment on the SelectInput - to pass to TextInput
        //   // InputProps={{
        //   //   //...params.InputProps,
        //   //   startAdornment: (
        //   //     <img className={classes.searchIcon} src={Icons.SEARCH} />
        //   //   ),
        //   // }}
        // />
      ) : (
        <>
          {/* check to add here a new 'show' selector condition*/}
          {showAddNewUserButton ? (
            <button
              disabled={props?.assignedParkers?.length >= LENGTHS.MAX_ASSIGNED_NUMBER_PER_TOKEN_LENGTH}
              onClick={handleAddNewUser} // scanNewFob
              type="button"
              className={classes.addCarButton}
            >
              <img src={Icons.ADD_BUTTON} />
              <span>{Strings.ADD_NEW_USER_BUTTON}</span>
            </button>
          ) : (
            <AllocationCard
              name={`${props?.selectedParker?.utronUser?.firstName} ${props?.selectedParker?.utronUser?.lastName}`}
              // fob={props?.fob}
              isActive={true}
              site={selectedSite}
              image={props?.selectedParker.utronUser?.image}
              showMenuItems={false}
            ></AllocationCard>
          )}
        </>
      )}

      <div className={classes.singleTokenAllocationContainer}>
        <AddSingleTokenAllocation
          {...props}
          setShowSummaryStep={setShowSummaryStep}
          selectedSite={selectedSite}
          handleAssignTokenToFob={handleAssignTokenToFob}
          setShowStepError={setShowStepError} // added
          setIsCurrentStepValid={props.setIsCurrentStepValid} // added
          isFobSkipped={props.isFobSkipped}
          dialingCode={props.dialingCode}
          setIsFobSkipped={props.setIsFobSkipped}
          ref={addSingleTokenAllocationRef}
          // ref={AddSingleTokenWithFobRef} // added
          handleClearAllTokens={handleClearAllTokens}
          setIsAddParkingAllocationInProcess={
            props.setIsAddParkingAllocationInProcess
          }
          setIsShowSaveChanges={props.setIsShowSaveChanges}
          occupiedTokens={occupiedTokens}
          totalSteps={props.totalSteps}
          handleChange={handleChange}
        />
        {/* Summary */}
        {/* !showAssigneFobOptions && !showExsistingParkingAllocation - when fob is not supported */ }
        {showSummaryStep && !showAssigneFobOptions && !showExsistingParkingAllocation && props.assignedParkers.length > 0 && /*occupiedTokens.length > 0 &&*/ (
          <div className={classes.summaryAllocationStep}>
            <Divider />
            <span className={classes.stepSubTitle}>
              {Strings.ASSIGNED_PARKERS_AND_FOBS}
            </span>
            {props?.assignedParkers?.map(parker => {
              return (
                <AllocationCard
                  //{...props} // fob - props.fob - change to: carUserToken.fob
                  // {...parker}
                  key={parker.utronUser.id}
                  parker={parker}
                  fob={parker?.carUserTokens[0]?.fob}
                  isActive={parker?.carUserTokens[0]?.isActive}
                  name={`${parker.utronUser?.firstName} ${parker.utronUser?.lastName}`}
                  image={parker.utronUser?.image}
                  site={selectedSite}
                  handleDeleteAssignedParker={handleDeleteAssignedParker}
                  showMenuItems={false}
                  showDeleteAction={true}
                ></AllocationCard>
              );
            })}
            {/* {occupiedTokens.map((token, index) => {
              return (
                <AllocationCard
                  {...props} // fob - props.fob - change to: carUserToken.fob
                  {...token}
                  name={`${props?.selectedParker?.firstName} ${props?.selectedParker?.lastName}`}
                  image={props?.selectedParker.image}
                  showMenuItems={false}
                ></AllocationCard>
              );
            })} */}
          </div>
        )}
      </div>

      {/* check to do the validation in the errorMessage */}
      {
        props.isStepSubmitted && hasStepErrors&&  (
          <div className={classes.error}>This step is required</div>
        )
      }
      </div>

      {/* old method example */}
      {/* <AddSingleTokenWithFob
        {...props}
        setShowSummaryStep={setShowSummaryStep}
        selectedSite={selectedSite}
        handleAssignTokenToFob={handleAssignTokenToFob}
        setShowStepError={setShowStepError} // added
        setIsCurrentStepValid={props.setIsCurrentStepValid} // added
        isFobSkipped={props.isFobSkipped}
        dialingCode={props.dialingCode}
        setIsFobSkipped={props.setIsFobSkipped}
        // ref={AddSingleTokenWithFobRef} // added
        handleClearAllTokens={handleClearAllTokens}
        setIsAddParkingAllocationInProcess={props.setIsAddParkingAllocationInProcess}
        setIsShowSaveChanges={props.setIsShowSaveChanges}
        occupiedTokens={occupiedTokens}
        totalSteps={props.totalSteps}
        handleChange={handleChange}
       /> */}
    </>
  );
}); // added ) - for forward ref

export default AssignAllocationStep;
